import { useContext } from 'react';
import '../assets/css/global.css';
import '@atlassian/learning-components/dist/styles/index.css';
import { RouteComponent } from 'react-resource-router';
import { Content } from '@atlaskit/page-layout';
import { RelayEnvironmentProvider } from 'react-relay/hooks';
import RelayEnvironment from '../services/relay';
import { Footer } from 'components/footer/Footer';

import { sentryConfig } from 'services/sentry/sentry';
import { normalizeUser, UserContext } from '../context/UserContext';
import { useTheme } from 'hooks/useTheme';
import { TopNavigationContents } from 'components/navigation/TopNavigationContents';

if (typeof window !== 'undefined') {
  const Sentry = require('@sentry/react');
  Sentry.init(sentryConfig);
}

export const App = () => {
  useTheme();
  const data = useContext(UserContext);
  const user = data?.user;

  return (
    <RelayEnvironmentProvider environment={RelayEnvironment}>
      <TopNavigationContents isLoggedIn={!!user} loggedInUser={normalizeUser(user)} />
      <Content>
        <RouteComponent />
      </Content>
      <Footer isLoggedIn={Boolean(user)} loggedInUser={normalizeUser(user)} />
    </RelayEnvironmentProvider>
  );
};
